// extracted by mini-css-extract-plugin
export var actionButton = "_wm-2";
export var card = "_wm-0";
export var disambiguationList = "_wm-3";
export var errorCard = "_wm-4";
export var row = "_wm-1";